// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xLoadingOverlay } from "@ces/App/Handlers/XNG/Common";
import React, { FC, useEffect } from "react";
import { useDispatch } from "react-redux";

interface OwnProps {
    children?: React.ReactNode;
    loading: boolean;
    id: string;
}

/**
 * Inner Component uses inside widgets and component
 * @param id
 * @param loading
 * @param children
 * @constructor
 */
const XngLoadingOverlay: FC<OwnProps> = ({ id, loading, children }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (loading) {
            dispatch(xLoadingOverlay({ key: "add", value: id }));
        } else {
            dispatch(xLoadingOverlay({ key: "clear", value: id }));
        }
    }, [loading]);

    return <>{children}</>;
};

export default XngLoadingOverlay;
